/* unplugin-vue-components disabled */import { render } from "./liveVideo.vue?vue&type=template&id=1eab2143&scoped=true"
import script from "./liveVideo.vue?vue&type=script&lang=js"
export * from "./liveVideo.vue?vue&type=script&lang=js"

import "./liveVideo.vue?vue&type=style&index=0&id=1eab2143&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eab2143"]])

export default __exports__